export enum LineType {
    Solid = "Solid",
    Dashed = "Dashed"
}